export default __webpack_public_path__ + "static/media/Group 17146.0cebc864.svg";